G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.RopeStatus = function(candy) {
  this.wrapperImg = null;

  G.BoardCandy.CandyStatus.call(this, candy);
};

G.BoardCandy.RopeStatus.prototype = Object.create(G.BoardCandy.CandyStatus.prototype);

G.BoardCandy.RopeStatus.prototype.init = function(candy, config) {
  G.BoardCandy.CandyStatus.prototype.init.call(this, candy, config);
  this.wrapperImg = G.makeImage(0, 0, "status_chain_2", 0.5, candy);
};

G.BoardCandy.RopeStatus.prototype.onMatch = function() {
  this.signals.onRemove.dispatch();
  this.remove();
  return false;
};

G.BoardCandy.RopeStatus.prototype.remove = function() {
  G.sfx.brick_break.play();
  G.sb("onCollectableRemove").dispatch('chain',this.candy);
  game.add.tween(this.wrapperImg)
    .to({
      width: this.wrapperImg.width*1.5,
      height: this.wrapperImg.height*1.5,
      alpha: 0
    }, 1000, Phaser.Easing.Cubic.Out,true)
    .onComplete.add(function() {
      this.wrapperImg.destroy();
    },this)

  G.sb("fx").dispatch('changeCircle',this.candy);
  G.sb("fxTop").dispatch('burstChainAnim',this.candy,this.candy);
  G.sfx.chain_rattle.play();
};